module.exports = require('./lib/websocket');


//////////////////
// WEBPACK FOOTER
// ./~/web3-eth/~/websocket/index.js
// module id = 1927
// module chunks = 0 1 3